import React, { Component } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import MyTooltip from '../../common/tooltip';
import SelectorCopy from '../../common/selectorCopy';
import CSVExport from '../../common/csvExport';

import './style.scss';
import { withNavigate } from '../../utility';
import moment from 'moment';

class expanableComponentDeviceAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headersCSV: [],
            dataCSV: []
        };
    }

    componentDidMount() {
        this.popolaCSV();
    }

    componentDidUpdate(prevProps) {
        // Se cambiano i dati, aggiorno il CSV
        if (prevProps.data !== this.props.data) {
            this.popolaCSV();
        }
    }

    /**
     * Popola il CSV da esportare con le informazioni ricevute
     */
    popolaCSV = () => {
        const headersTemp = [
            { label: "Device ID", key: "deviceId" },
            { label: "Accesso", key: "dateAccess" },
            { label: "User Agent", key: "userAgent" },
            { label: "IP Address", key: "ipAddress" }
        ];

        const dataTemp = this.props.data?.details?.map((item) => ({
            deviceId: item.devices.map((elem) => {
                if (item.devices === null || item.devices === undefined) {
                    return '';
                } else {
                    return elem;
                }
            }),
            dateAccess: this.formatData(item.ts),
            userAgent: item.ua || '',
            ipAddress: item.ip || ''
        })) ?? [];

        this.setState({
            headersCSV: headersTemp,
            dataCSV: dataTemp
        });
    }

    /**
     * Dato un id rimando alla sezione corrispondente
     */
    goToPage = (deviceId) => {
        this.props.setIdPlayerForDetail(deviceId);
        this.props.handleNavigation(this.props.navigate, `/player/devices`);
    }

    /**
     * Data una data in formato ISO, restituisce una data formattata
     * formato: September 4 1986 - 08:30:00 PM
     */
    formatData = (data) => {
        if (!data) return '';
        return moment(data).format('LL') + ' - ' + moment(data).format('LTS');
    }

    render() {
        const { data } = this.props;

        return (
            <div className="tabExpanablePlayer">
                <div className="col-12 text-center">
                    <CSVExport
                        data={this.state.dataCSV}
                        headers={this.state.headersCSV}
                        filename={`loginInfo-${data.deviceId}.csv`}
                    />
                </div>

                {
                    data?.details?.map((el, key) => (
                        <div className="row" key={key} style={{ marginBottom: '2rem' }}>
                            <div className="col-sm-6 col-12">
                                <TextField
                                    label="IP Address"
                                    variant="standard"
                                    fullWidth
                                    value={el.ip || ''}
                                    InputProps={{
                                        readOnly: true,
                                        endAdornment: el.devices?.length > 0 && (
                                            <InputAdornment position="end">

                                                {/* 1 device */}
                                                {el.devices.length === 1 && (
                                                    <>
                                                        <SelectorCopy
                                                            item={el.devices[0]}
                                                            infoNotify={this.props.infoNotify}
                                                            noLabel
                                                        />
                                                        <span
                                                            className="clickForPlayer"
                                                            onClick={() => this.goToPage(el.devices[0])}
                                                        >
                                                            <MyTooltip
                                                                title="Vai a questo ID"
                                                                position="top"
                                                                content={<i className="fas fa-share-square"></i>}
                                                            />
                                                        </span>
                                                    </>
                                                )}

                                                {/* più devices */}
                                                {el.devices.length > 1 && (
                                                    <MyTooltip
                                                        title={el.devices.map((device, i) => (
                                                            <ul key={i}>
                                                                <li>{device}</li>
                                                            </ul>
                                                        ))}
                                                        position="top"
                                                        content={
                                                            <span className="moreProd">
                                                                Vedi devices
                                                                {
                                                                    el.devices.length === 1
                                                                        ? el.devices[0]
                                                                        : `(${el.devices.length})`
                                                                }
                                                            </span>
                                                        }
                                                    />
                                                )}

                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </div>

                            <div className="col-sm-6 col-12">
                                <TextField
                                    value={this.formatData(el.ts)}
                                    label="Data"
                                    variant="standard"
                                    fullWidth
                                />
                            </div>

                            <div className="col-sm-12 col-12">
                                <TextField
                                    value={el.ua || ''}
                                    label="User Agent"
                                    variant="standard"
                                    fullWidth
                                />
                            </div>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default withNavigate(expanableComponentDeviceAccess);